{
  "id": 27,
  "location": "paris",
  "difficulty": "normal",
  "moves": 19,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "macaron", "count": 28 }
  ],
  "stars": [3350, 4360],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . X . . X . .",
    ". . X . . X . .",
    ". . x . . x . .",
    ". . x . . x . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.691, "movesLeft": 4.5, "closeLosses": 0.128, "target": 0.66 }
}
